import React, { useEffect } from 'react'
import CareerDetailForm from './CareerDetailForm'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function CareerDetails() {

    // window.onbeforeunload = () => {
    //     localStorage.clear();
    //   }
    return (
        <div className='formBody'>
            <UserHeader /> 
            <CareerDetailForm/>
             <UserFooter />
        </div>
    )
}

export default CareerDetails